// extracted by mini-css-extract-plugin
export var errorIcon = "_lk-1";
export var nameLogo = "_lk-0";